import {useGetWhatsAppTemplateDetails} from '@/components/Drawer/hooks/useWhatsAppTemplateDetails'
import WhatsAppTemplateButtonGroup from '@/components/Drawer/WhatsAppTemplateButtonGroup'
import WhatsAppTemplateMobilePreview from '@/components/Drawer/WhatsAppTemplateMobilePreview'
import {ROUTES} from '@/config/constants'
import {useAuth} from '@/hooks/useAuth'
import {MessageTemplateDrawerStatusEnum} from '@/types/MessageTemplateDrawerStatusEnum'
import {UserRoleEnumSchema} from '@/types/UserRole'
import {WhatsappTemplateStatus} from '@/types/WhatsappTemplate'
import {useIntl} from 'react-intl'
import {useNavigate, useParams} from 'react-router-dom'

interface Props {
  updateDrawerStatus: (value: MessageTemplateDrawerStatusEnum) => void
}

export default function WhatsAppTemplateDetails({updateDrawerStatus}: Props): React.JSX.Element {
  const {formatMessage} = useIntl()
  const {id: whatsAppTemplateId} = useParams()
  const navigate = useNavigate()

  const {data: templateDetailsData} = useGetWhatsAppTemplateDetails(whatsAppTemplateId)

  const onEditTemplate = () => {
    navigate(`${ROUTES.MESSAGE_TEMPLATE_EDIT.replace(':id', whatsAppTemplateId || '')}`)
    updateDrawerStatus(MessageTemplateDrawerStatusEnum.createWhatsAppTemplate)
  }

  const {userRole} = useAuth()
  // Only Admin user can edit the template, and it cannot be edited if it is approved
  const isEditDisabled =
    userRole !== UserRoleEnumSchema.enum.admin ||
    templateDetailsData?.status === WhatsappTemplateStatus.PENDING_APPROVAL

  return (
    <div data-testid="whatsapp-template-details" className="ml-4 flex w-full flex-col items-start">
      <div className="mb-4 text-lg font-bold text-text-primary">{templateDetailsData?.name}</div>
      <WhatsAppTemplateMobilePreview templateMessage={templateDetailsData?.message ?? ''} />
      <WhatsAppTemplateButtonGroup
        testIdPrimary="whatsapp-template-edit"
        onClickPrimary={onEditTemplate}
        primaryButtonLabel={formatMessage({id: 'WHATSAPP_TEMPLATE_BUILDER.EDIT_BUTTON_LABEL'})}
        isPrimaryDisabled={isEditDisabled}
      />
    </div>
  )
}
